import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DialogService {
  constructor(
    public dialog: MatDialog
  ) {}

  onOpenDialog(classRef: any, input: any, width?: number): Observable<any> {
    const dialogRef = this.dialog.open(classRef, {
      width: width ? `${width}%` : "70%",
      maxWidth: "1440px",
      autoFocus: false,
      data: input,
      maxHeight: "90vh",
    });
    return dialogRef.afterClosed();
  }

  onOpenDialogMobile(classRef: any, input: any): Observable<any> {
    const dialogRef = this.dialog.open(classRef, {
      width: "100%",
      autoFocus: true,
      data: input,
      height: "100vh",
      maxHeight: "100vh",
      maxWidth: "100%",
    });
    return dialogRef.afterClosed();
  }

  onOpenDialogResponsive(isMobile: boolean, classRef: any, input: any, width?: number): Observable<any> {
    if (!isMobile) {
      return this.onOpenDialog(classRef, input, width);
    } else {
      return this.onOpenDialogMobile(classRef, input);
    }
  }
}